import React from "react";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import CusButton from "../../mui/custom_button/CusButton";
import { removeHistoryId } from "../../../store/gamesSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../store/index.ts";
import CusImage from "../../custom_image/CusImage.jsx";

export default function DeleteHisGameModal({ isOpen, closeModal, currentGame }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currency = useAppSelector((state) => state.user.currency);

  const id = currentGame.game_id || currentGame.id;

  const onDeleteClick = () => {
    dispatch(removeHistoryId({ currency, gameId: id }));
    closeModal();
  };

  return (
    <DefaultModal miniModal isOpen={isOpen} closeModal={closeModal} classModal="chose-mode">
      <h2>{t("Delete the game?")}</h2>
      <div className="chose-mode__content">
        <p>{t("Do you really want to remove the game from your history?")}</p>

        <div className="chose-mode__game">
          <CusImage url={currentGame.image} alt={"image " + currentGame.name} />

          <span className="chose-mode__game__title">{currentGame.name}</span>
        </div>

        <div className="buttons">
          <CusButton color={"gradient-blue"} text={t("Close")} onClick={closeModal} />
          <CusButton color="primary" text={t("Delete")} onClick={onDeleteClick} />
        </div>
      </div>
    </DefaultModal>
  );
}
